import { appConfig } from 'config/environment/appConfig'

import { PickPointFileType } from 'sections/LKSection/shared/PickPointSharedModule/types'

export const urlForSecretImages = `${appConfig.API_URL}api/v2/manage/orders/images`

type PickPointFileItem = {
  fileType: PickPointFileType
  label: string
  description: string
  dataTestId: string
}

export const createOrderPhotoItems: PickPointFileItem[] = [
  {
    fileType: PickPointFileType.generalPhoto,
    label: 'Фасад здания днем',
    description: 'Дневное фото фасада здания',
    dataTestId: 'generalPhoto',
  },
  {
    fileType: PickPointFileType.nightlyGeneralPhoto,
    label: 'Фасад здания с выделенной зоной',
    description: 'Фото фасада здания с выделенным местом',
    dataTestId: 'nightlyGeneralPhoto',
  },
  {
    fileType: PickPointFileType.clientAreaPhoto,
    label: 'Помещение внутри',
    description: 'Фото помещения ПВЗ',
    dataTestId: 'clientAreaPhoto',
  },
  {
    fileType: PickPointFileType.fittingRoomsPhoto,
    label: 'Входная группа',
    description: 'Фото входа в сам ПВЗ',
    dataTestId: 'fittingRoomsPhoto',
  },
]

export const signboardPhotoItems: PickPointFileItem[] = [
  {
    fileType: PickPointFileType.generalPhoto,
    label: 'Фото фасада с вывеской днём',
    description: 'Дневное фото фасада с вывеской',
    dataTestId: 'generalPhoto',
  },
  {
    fileType: PickPointFileType.nightlyGeneralPhoto,
    label: 'Фото фасада с вывеской ночью',
    description: 'Ночное фото фасада с вывеской',
    dataTestId: 'nightlyGeneralPhoto',
  },
  {
    fileType: PickPointFileType.bracketPhoto,
    label: 'Фото панель-кронштейна',
    description: 'Фото фасада здания кронштейн',
    dataTestId: 'bracketPhoto',
  },
]

export const pickPointPhotoItems: PickPointFileItem[] = [
  {
    fileType: PickPointFileType.generalPhoto,
    label: 'Фото фасада с вывеской днём',
    description: 'Дневное фото фасада с вывеской',
    dataTestId: 'generalPhoto',
  },
  {
    fileType: PickPointFileType.nightlyGeneralPhoto,
    label: 'Фасад здания с выделенной зоной',
    description: 'Фото фасада здания с выделенным местом',
    dataTestId: 'nightlyGeneralPhoto',
  },
  {
    fileType: PickPointFileType.bracketPhoto,
    label: 'Фото панель-кронштейна',
    description: 'Фото фасада здания кронштейн',
    dataTestId: 'bracketPhoto',
  },
  {
    fileType: PickPointFileType.clientAreaPhoto,
    label: 'Клиентская зона',
    description: 'Фото помещения ПВЗ',
    dataTestId: 'clientAreaPhoto',
  },
  {
    fileType: PickPointFileType.fittingRoomsPhoto,
    label: 'Примерочные',
    description: 'Фото входа в сам ПВЗ',
    dataTestId: 'fittingRoomsPhoto',
  },
  {
    fileType: PickPointFileType.warehouseAreaPhoto,
    label: 'Складская зона',
    description: 'Фото помещения складской зоны',
    dataTestId: 'warehouseAreaPhoto',
  },
  {
    fileType: PickPointFileType.surveillancePhoto,
    label: 'Видеонаблюдение',
    description: 'Фото установленной камеры',
    dataTestId: 'surveillancePhoto',
  },
]

export const pickPointVideoItem = {
  label: 'Видеопрогулка',
  description: 'Видео от первого лица',
  dataTestId: 'orderVideo',
}

export const baseLeaseDocumentData = {
  label: 'Договор аренды',
  description: 'Договор аренды или документ',
  dataTestId: 'leaseDocument',
}

export const baseBtiDocumentData = {
  label: 'План БТИ',
  description: 'План БТИ должен быть с отметками',
  dataTestId: 'btiDocument',
}

export const pickPointDocumentForEditAreaItems = [
  {
    fileType: PickPointFileType.leaseDocumentEditArea,
    ...baseLeaseDocumentData,
  },
  {
    fileType: PickPointFileType.btiDocumentEditArea,
    ...baseBtiDocumentData,
  },
]
